import {
    AccountingInvoiceOpen,
    IConnectionService,
    Ulid,
} from "@kase/my-marathon-communication";
import { store } from "~/core/store";
import { upsertOne } from "~/utils";
import { getAttachment, loadThumbnails } from "../expense/attachment";
import { ExpenseReceipt } from "../expense/interfaces";
import { GuardedValue } from "../interfaces";
import {
    ApproveEntityType,
    ApproveFilter,
    ApprovePrivateFilter,
} from "./interfaces";

export const getRowId = (parent: string, item: AccountingInvoiceOpen) =>
    `${parent}-${item.id.toString()}`;

export const getEntityId = (
    type: ApproveEntityType,
    item: { company: string; id: Readonly<Ulid> },
) => `${type}-${item.company}-${item.id.toString()}`;

export const getPrivateFilterKey = (filter: ApprovePrivateFilter) =>
    `${filter.status}|${filter.companies.toSorted().join(",")}`;

export const getFilterKey = (filter: ApproveFilter, api = false) =>
    `${filter.statuses.toSorted().join(",")}|${filter.companies
        .toSorted()
        .join(
            ",",
        )}-${filter.types ? filter.types.toSorted().join(",") : ""}-${api}`;

export const splitCompanies = (companies: string[]) => {
    const { company } = store.api;
    const invoiceCompanies = companies.filter(
        (c) => company.getByCode(c)?.module_lev,
    );
    const expenseCompanies = companies.filter(
        (c) => company.getByCode(c)?.module_bok,
    );

    return [invoiceCompanies, expenseCompanies] as const;
};

export const loadExpenseAttachments = async (
    approvalId: string,
    receipt: ExpenseReceipt,
    connection: GuardedValue<IConnectionService>,
    company: GuardedValue<string>,
    previewState: Readonly<Record<string, boolean>>,
) => {
    const api = store.api;
    const con = connection.value;

    receipt.loading.value = true;

    api.expense.duplicate.check(receipt._attachments.map((a) => a.toString()));

    const promises = receipt._attachments.map(async (id) => {
        const attachment = await getAttachment(
            con,
            company.value,
            receipt._id,
            id,
        );

        api.expense.ocr.process(attachment.blob_id, attachment.id);

        if (previewState[approvalId]) {
            await loadThumbnails(attachment);
        }

        receipt.attachments.value = upsertOne(
            receipt.attachments.peek().slice(),
            attachment,
            "id",
        );
    });

    const result = await Promise.allSettled(promises);

    result
        .filter((r) => r.status === "rejected")
        .forEach((r) => {
            console.log(
                "[approval.loadExpenseAttachments] Failed to load attachment",
                r,
            );
        });

    receipt.loading.value = false;
    receipt.tag.value = receipt.tag.peek() + 1;
};
